<template>
  <v-container id="camerasLayout"  class="ml-1 my-0 py-0" style="overflow-y: hidden !important">
    <v-img id="fakeMarker" v-show="markerDragging" 
    :src="require('../../public/static/marker-icon.png')"
    :draggable="true"
    @dragover.stop
    max-width="25px" max-height="41px" style="z-index:1000;position:absolute"
    />
    <v-row v-for="(videoRow, index) in camerasRows" :key="'r'+index">
      <v-col :cols="12/camerasColumns" class="ma-0 pa-0 pr-1 " v-for="(videoCol, index) in camerasColumns" :key="'r'+index">
        <component :is="playerOrMap(videoRow, videoCol)" @changeComponent="reRenderFromStream" 
        :resource="players[(((videoRow -1)*camerasRows)+videoCol)-1]" :height="playerHeight" :selfIndex="(((videoRow -1)*camerasRows)+videoCol)-1"
        :key="playerKey((((videoRow -1)*camerasRows)+videoCol)-1)" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components:{
    VideoStream: ()=> import('@/components/material/VideoStream'),
    CamerasMap: ()=> import('@/components/material/Map')
  },
  data(){
    return {
      players: [
       {
          bd:'', 
          id: '', 
          name:'', 
          type:''
        }
      ],
      playersKeys: [0],
      index: 0,
      hasmap: false,
      cursor:{
        x: 0,
        y:0
      }
    }
  },
  computed: {
    windowSize:function(){
      return this.$store.getters.getWindowSize
    },
    mobile:function(){
      return this.$store.getters.getMobile
    },
    resource: function(){
      return this.$store.state.resource
    },
    navDrawerHeight: function(){
      return this.$store.getters.getNavDrawerHeight
    },
    footerHeight:function(){
      return 12 / window.innerHeight
    },
    activeItems:{
      get(){
        return this.$store.getters.getActiveItems
      },
      set(value){
        this.$store.commit('setActiveItems', value)
      }
    },
    markerDragging:{
      get(){
        return this.$store.getters.getMarkerDragging
      }
    },
    markerKey:{
      get(){
        return this.$store.getters.getMarkerKey
      }
    },
    camerasInDisplay:{
      get(){
        return this.$store.getters.getCamerasInDisplay 
      }
    },
    camerasColumns:{
      get(){
        return Math.sqrt(this.camerasInDisplay)
      }
    },
    camerasRows:{
      get(){
        return Math.sqrt(this.camerasInDisplay)
      }
    },
    playerHeight: function(){
      return (this.navDrawerHeight - (this.navDrawerHeight*0.05)) / this.camerasRows  
    },
    
  },
  watch:{
    camerasInDisplay:function(newVal,oldVal){
      if(newVal === oldVal){
        return null
      }
      if(this.players.length < newVal){
        for(var i=this.players.length; i<newVal; i++){
          this.players.splice(i,0,{
            bd:'', 
            id: '', 
            name:'', 
            type:''
          })
          this.playersKeys.splice(i,0,0)
        }
      } else if(this.players.length>newVal){
        this.players.splice(newVal, this.players.length-newVal)
        this.playersKeys.splice(newVal,this.playersKeys.length- newVal )
      }
    },
    resource: function(newVal,oldVal){
      if(newVal === oldVal){
        return null
      }
      if(newVal.operation ==="add"){
        if(this.players.some(p=> p.id === newVal.id)){
          return null
        }        
        var overridePlayer= this.index
        if(this.players.filter(p=> p.id !== '').length < this.camerasInDisplay){
          let emptyPlayer = this.players.findIndex(res=> res.id==='')
          if(emptyPlayer !== -1){
            overridePlayer = emptyPlayer
          }
        } else {
          overridePlayer = this.index
        }
        this.videoStreamReRender(overridePlayer, newVal)        
      } else if(newVal.operation ==="remove"){
        this.videoStreamReRender(this.players.findIndex(res=> res.id===newVal.id), {id:'',name:'',operation:''})
        var removeIndex = this.activeItems.findIndex(res=> res===newVal.id)
        if(removeIndex > -1){
          this.activeItems.splice(removeIndex, 1)
        }
      }
    },
    markerDragging: function (newVal,oldVal){
      if(newVal === oldVal)
        return null
      var camerasLayout = document.getElementById('camerasLayout')
      camerasLayout.addEventListener('mousemove',this.getCursorPosition)      
    }
  },
  methods: {
    playerOrMap(videoRow,videoCol){
      return ( this.camerasInDisplay !==1 && !this.$config.DISABLED_MAP && videoRow=== 1 && videoCol===this.camerasColumns )?'CamerasMap':'VideoStream'
    },
    videoStreamReRender(index,resource){
      console.log('index',index)
      this.players.splice(index,1,resource)
      this.playersKeys[index] ++
      if(resource.id===''){
        this.index = index
      } else if(index===this.camerasInDisplay-1){
        this.index= 0
      } else if(index < this.camerasInDisplay-1){
        this.index ++
      }
    },
    reRenderFromStream(value) {
      var index = this.players.findIndex(player=> player.id === value.id)
      var item = {
        bd:'', 
        id: value.id, 
        name:value.name, 
        type:'',
        operation: "add"
      }
      if(index!==-1){
        this.messageFromStream = value
        this.videoStreamReRender(index,{
          bd:'', 
          id: '', 
          name:'', 
          type:'',
          operation: ''
        })
        this.activeItems.splice(index, 1)
        return null
      }
      console.log('rerender', value)
      this.videoStreamReRender(value.index,item)
      this.activeItems.splice(index, 1, item.id)      
    },
    playerKey(index){
      return (['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P'])[index] + this.playersKeys[index]
    },
    getCursorPosition(e){
      this.cursor.x =(e.pageX || e.clientX)
      this.cursor.y = (e.pageY || e.clientY)
      var marker = document.getElementById('fakeMarker')
      marker.style.top = this.cursor.y - 48 -43 +'px';
      marker.style.left = this.cursor.x - this.$store.getters.getNavigationDrawerWidth - 13 + 'px';
      var camerasLayout = document.getElementById('camerasLayout')
      camerasLayout.addEventListener('mouseup', this.release)   
    },
    release(){
      if(this.$store.getters.getMarkerInfo.id===undefined)
        return null
      var camerasLayout = document.getElementById('camerasLayout')
      camerasLayout.removeEventListener('mousemove', this.getCursorPosition)
      camerasLayout.removeEventListener('mouseup', this.release)      
      var event= document.createEvent('DragEvent')
      event.initEvent("drop", true, true);
      var playerid= this.$store.getters.getPlayerHovered
      if(playerid!==undefined){
        var player= document.getElementById(playerid)
        player.dispatchEvent(event)
      } else {
        this.$store.dispatch('setOffMarkerDragging')
      }
    }
  }
}
</script>

<style>
  #camerasLayout{
    margin: 0 auto!important
  }

</style>